import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import Footer from "../../components/Footer";
import DFNavbar from "../../components/Navbar";
import dflat_icon from "./../../img/dflat/icon.png";
import dflat_screen from "./../../img/dflat/screen.png";
import dflat_ground_detection from "./../../img/dflat/ground-detection.gif";
import dflat_manual_filtering from "./../../img/dflat/manual-filtering.gif";
import dflat_manual_filtering2 from "./../../img/dflat/manual-filtering2.gif";
import dflat_ortho_dtm_chm from "./../../img/dflat/ortho-dtm-chm.png";
import { ScrollToTop } from "../../components/ScrollToTop";
import { DOWNLOAD_ROUTE } from "../../consts/routes";
import { Helmet } from "react-helmet";
import i18n from "../../i18n/configs";

/**
 * DF LAT詳細画面
 * @returns JSX.Element
 */
const DetailDflat = () => {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col">
            <Helmet>
                <title>{t("DetailDflat.meta.title")}</title>
                <meta name="description" content={t("DetailDflat.meta.description")} />
            </Helmet>
            <ScrollToTop />
            <DFNavbar bottomPadding={true} />
            <div className="flex-grow items-center justify-center px-6 py-8 pt-20 lg:px-20">
                <div className="mx-auto max-w-screen-md px-4 md:px-8">
                    <div className="flex items-center justify-center">
                        <img className="h-20 w-20 p-3" src={dflat_icon} alt="dflat" />
                        <h1 className="text-center text-2xl font-bold text-gray-800 sm:text-3xl ">DF LAT</h1>
                    </div>
                </div>

                <div className="mx-auto mt-10 flex max-w-3xl items-center justify-center">
                    {i18n.language === "ja"
                        ? "「DF LAT」詳細ページは移行しました。"
                        : "The 'DF LAT' details page has been moved."}
                </div>
                <div className="mx-auto flex max-w-3xl items-center justify-center">
                    <a
                        href={
                            i18n.language === "ja"
                                ? "https://deepforest-tech.co.jp/df-lat/"
                                : "https://deepforest-tech.co.jp/en/df-lat/"
                        }
                        className="link-text mt-4 text-sm font-bold"
                    >
                        {i18n.language === "ja" ? "新しいページへ移動する" : "Go to the new page."}
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default DetailDflat;
